interface Props {
  submit?: boolean;
}
const SvgAddressDefault: React.FC<Props> = ({ submit = false }) => {
  return (
    <svg
      style={submit ? { marginInlineEnd: 8, transform: "scale(1.5,1.5)" } : {}}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10445_61289)">
        <path
          d="M16.3018 3.86986C16.1558 3.87412 16.0171 3.93506 15.9151 4.03978L6.18783 13.7671L2.08554 9.66478C2.0337 9.6108 1.97162 9.5677 1.90293 9.53801C1.83423 9.50832 1.7603 9.49263 1.68546 9.49187C1.61063 9.49111 1.53639 9.50529 1.46711 9.53358C1.39782 9.56187 1.33488 9.60369 1.28196 9.65661C1.22904 9.70953 1.18721 9.77248 1.15892 9.84176C1.13063 9.91105 1.11646 9.98528 1.11722 10.0601C1.11798 10.135 1.13366 10.2089 1.16335 10.2776C1.19304 10.3463 1.23614 10.4084 1.29013 10.4602L5.79013 14.9602C5.89562 15.0656 6.03867 15.1249 6.18783 15.1249C6.33699 15.1249 6.48004 15.0656 6.58554 14.9602L16.7105 4.83519C16.7917 4.75616 16.8471 4.65447 16.8695 4.54343C16.8919 4.43239 16.8802 4.31718 16.8361 4.21286C16.7919 4.10855 16.7173 4.02 16.622 3.9588C16.5267 3.8976 16.4151 3.8666 16.3018 3.86986Z"
          fill={"currentColor"}
        />
      </g>
      <defs>
        <clipPath id="clip0_10445_61289">
          <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAddressDefault;
